var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('a-alert',{staticClass:"mb-3",attrs:{"type":"warning","show-icon":"","message":_vm.$t('aice.aiproxy.usage.truncated_title'),"description":_vm.$t('aice.aiproxy.usage.truncated_desc')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }